import { gql } from "@apollo/client";

export default gql`
  query getChangelogSubscribers($input: ListChangelogSubscribersInput){
    getChangelogSubscribers(input: $input){
        success
        data{
            docs{
                _id
                firstName
                lastName
                email
                phone
                language
                customer
                prefs{
                    web
                    mobile
                    email
                    whatsapp
                }
                createdAt
            }
            totalDocs
            hasNextPage
        }
        error
        message
    }
}
`
